import React from 'react';

const FinancialSummary = ({ inscription }) => {
  if (!inscription) return null;

  // Calculs corrects des montants
  const scolaritePaye = inscription?.montant_paye || 0;
  const scolariteRestant = inscription?.montant_impaye || 0;
  const scolariteTotal = inscription?.montant_total || 0;

  const optionsPaye = inscription?.montant_options_paye || 0;
  const optionsRestant = inscription?.montant_options_impaye || 0;
  const optionsTotal = inscription?.montant_options || 0;

  const fraisInscriptionMontant = inscription?.frais_inscription_montant || 0;
  const fraisInscriptionPaye = inscription?.frais_inscription_paye ? fraisInscriptionMontant : 0;
  const fraisInscriptionRestant = inscription?.frais_inscription_paye ? 0 : fraisInscriptionMontant;

  // Calculs des totaux
  const totalPaye = Number(scolaritePaye) + Number(optionsPaye) + Number(fraisInscriptionPaye);
  const totalRestant = Number(scolariteRestant) + Number(optionsRestant) + Number(fraisInscriptionRestant);
  const montantGlobal = Number(inscription?.montant_global) || 0;

  // Calcul de la progression

  return (
    <div className="space-y-6">
      {/* Barre de progression principale */}
      
      {/* Détails des paiements */}
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
        {/* Frais de scolarité */}
        <div className="bg-white rounded-lg p-6 shadow-sm">
          <h3 className="text-gray-500 text-sm font-medium mb-2">Frais de scolarité</h3>
          <p className="text-2xl font-bold text-gray-900 mb-4">
            {scolariteTotal.toLocaleString()} FCFA
          </p>
          <div className="space-y-1">
            <div className="flex justify-between text-sm">
              <span className="text-green-600">Payé:</span>
              <span className="font-medium text-green-600">{scolaritePaye.toLocaleString()} FCFA</span>
            </div>
            <div className="flex justify-between text-sm">
              <span className="text-red-600">Reste:</span>
              <span className="font-medium text-red-600">{scolariteRestant.toLocaleString()} FCFA</span>
            </div>
          </div>
        </div>

        {/* Frais d'inscription */}
        <div className="bg-white rounded-lg p-6 shadow-sm">
          <h3 className="text-gray-500 text-sm font-medium mb-2">Frais d'inscription</h3>
          <p className="text-2xl font-bold text-gray-900 mb-4">
            {fraisInscriptionMontant.toLocaleString()} FCFA
          </p>
          <div className="mt-2">
            <span className={`inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium ${
              inscription?.frais_inscription_paye ? 'bg-green-100 text-green-800' : 'bg-red-100 text-red-800'
            }`}>
              {inscription?.frais_inscription_status}
            </span>
          </div>
        </div>

        {/* Options complémentaires */}
        <div className="bg-white rounded-lg p-6 shadow-sm">
          <h3 className="text-gray-500 text-sm font-medium mb-2">Options complémentaires</h3>
          <p className="text-2xl font-bold text-gray-900 mb-4">
            {optionsTotal.toLocaleString()} FCFA
          </p>
          <div className="space-y-1">
            <div className="flex justify-between text-sm">
              <span className="text-green-600">Payé:</span>
              <span className="font-medium text-green-600">{optionsPaye.toLocaleString()} FCFA</span>
            </div>
            <div className="flex justify-between text-sm">
              <span className="text-red-600">Reste:</span>
              <span className="font-medium text-red-600">{optionsRestant.toLocaleString()} FCFA</span>
            </div>
          </div>
        </div>

        {/* Total */}
        <div className="bg-white rounded-lg p-6 shadow-sm">
          <h3 className="text-gray-500 text-sm font-medium mb-2">Total</h3>
          <p className="text-2xl font-bold text-gray-900 mb-4">
            {montantGlobal.toLocaleString()} FCFA
          </p>
          <div className="space-y-1">
            <div className="flex justify-between text-sm">
              <span className="text-green-600">Payé:</span>
              <span className="font-medium text-green-600">{totalPaye.toLocaleString()} FCFA</span>
            </div>
            <div className="flex justify-between text-sm">
              <span className="text-red-600">Reste:</span>
              <span className="font-medium text-red-600">{totalRestant.toLocaleString()} FCFA</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default FinancialSummary;
